export function showLoadingScreen() {
  const loadingScreen = document.getElementById("loadingScreen");
  const loadingLogo = document.getElementById("loadingLogo");
  loadingScreen.classList.add("is-active");
  loadingLogo.classList.add("is-active");
}

export function hideLoadingScreen() {
  const loadingScreen = document.getElementById("loadingScreen");
  const loadingLogo = document.getElementById("loadingLogo");
  loadingScreen.classList.remove("is-active");
  loadingLogo.classList.remove("is-active");
}
